export default "__VITE_ASSET__C1U3YnJc__"